module.exports = {
    'container': require('./container.mustache'),
    'flash': require('./flash.mustache'),
    'forbidden': require('./forbidden.mustache'),
    'generic-error': require('./generic-error.mustache'),
    'generic-message': require('./generic-message.mustache'),
    'insufficient-funds': require('./insufficient-funds.mustache'),
    'max-win-cap': require('./max-win-cap.mustache'),
    'responsible-gaming': require('./responsible-gaming.mustache'),
    'responsible-gaming-error': require('./responsible-gaming-error.mustache'),
    'responsible-gaming-server-dialog': require('./responsible-gaming-server-dialog.mustache'),
    'recoverable-error': require('./recoverable-error.mustache'),
    'recoverable-insufficient-funds': require('./recoverable-insufficient-funds.mustache'),
    'responsible-end-session': require('./responsible-end-session.mustache'),
    'session-timeout': require('./session-timeout.mustache'),
    'country-blocked': require('./country-blocked.mustache'),
    'server-dialog': require('./server-dialog.mustache'),
    'error-message': require('./error-message.mustache')
};
